export enum OnsiteInterviewSortableField {
  JobDateTime = 'date',
  Status = 'status',
}
